// MUI Grid widths are twelfths, and the picker gives each export section one column of a single
// row. Fixed at 4 this suited only the three-section route export: every other caller passes one
// section, which then occupied a third of the modal while its field labels wrapped.
//
// Floored, so five or more sections share the row rather than overflowing it, and never below 1.
export const exportColumnWidth = (typeCount) => Math.max(1, Math.floor(12 / (typeCount || 1)));
